import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

const LanguageContext = createContext(null);

const getInitialLanguage = () => {
  const storedLanguage = sessionStorage.getItem("language");
  return storedLanguage === "EN" ? "EN" : "ES";
};

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(getInitialLanguage);

  useEffect(() => {
    sessionStorage.setItem("language", language);
    document.documentElement.setAttribute(
      "lang",
      language === "EN" ? "en" : "es"
    );

    window.dispatchEvent(
      new CustomEvent("app:language-changed", {
        detail: { language },
      })
    );
  }, [language]);

  useEffect(() => {
    const handleLegacyLanguageToggle = (event) => {
      if (event.detail?.language) setLanguage(event.detail.language);
    };

    window.addEventListener("app:language-toggle", handleLegacyLanguageToggle);
    return () => {
      window.removeEventListener("app:language-toggle", handleLegacyLanguageToggle);
    };
  }, []);

  const value = useMemo(
    () => ({
      language,
      setLanguage,
      toggleLanguage: () =>
        setLanguage((prevLanguage) => (prevLanguage === "EN" ? "ES" : "EN")),
    }),
    [language]
  );

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);

  if (!context) {
    throw new Error("useLanguage must be used inside LanguageProvider");
  }

  return context;
}
